<template>
  <v-btn
    :loading="loading"
    block
    small
    outlined
    color="accent"
    @click="playPauseButton.handler"
  >
    {{ playPauseButton.text }}
    <v-icon right v-text="playPauseButton.icon" />
  </v-btn>
</template>

<script>
import Repositories from 'src/repositories'
import { mapActions } from 'vuex'

export default {
  name: 'PlayPauseSessionButton',
  props: {
    session: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    playPauseButton () {
      return this.session.pause
        ? {
          icon: 'mdi-play',
          handler: this.play,
          text: this.$t('animation.menu.buttons.play'),
        }
        : {
          icon: 'mdi-pause',
          handler: this.pause,
          text: this.$t('animation.menu.buttons.pause'),
        }
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    ...mapActions('animation', {
      patchSession: 'patchSession',
    }),
    async play () {
      this.loading = true
      try {
        const patch = { id: this.session.id, pause: false }
        await Repositories.trainingSession.session.patch(patch)
        this.patchSession(patch)
        this.showSuccessNotification(this.$t('animation.menu.session.play.success'))
      }
      catch (error) {
        this.showErrorNotification(this.$t('animation.menu.session.play.error'))
      }
      finally {
        this.loading = false
      }
    },
    async pause () {
      this.loading = true
      try {
        const patch = { id: this.session.id, pause: true }
        await Repositories.trainingSession.session.patch(patch)
        this.patchSession(patch)
        this.showSuccessNotification(this.$t('animation.menu.session.pause.success'))
      }
      catch (error) {
        this.showErrorNotification(this.$t('animation.menu.session.pause.error'))
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
